import { createContext, Dispatch, SetStateAction } from 'react'

import { UploadFile } from 'types'
import { UploadFileValidators } from '../..'

export type UploadManagerContextType = UploadFileValidators & {
  file: UploadFile
  setFile: Dispatch<SetStateAction<UploadFile>>
}

const defaultValues: UploadManagerContextType = {
  file: {},
  setFile: () => {},
}

const UploadManagerContext = createContext<UploadManagerContextType>(defaultValues)

export default UploadManagerContext
